// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsEditOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.553 4.391a.25.25 0 0 0-.354 0L17.131 5.46a.25.25 0 0 0 0 .354l1.057 1.057a.25.25 0 0 0 .354 0l1.067-1.068a.25.25 0 0 0 0-.354zm-1.439 3.907a.25.25 0 0 0 0-.353l-1.056-1.057a.25.25 0 0 0-.354 0L4.55 18.05l-.318 1.424a.25.25 0 0 0 .297.3l1.432-.314zm.22-5.872c.613-.613 1.555-.528 2.103.02l2.118 2.119c.547.547.631 1.489.02 2.1L7.292 20.956a1.632 1.632 0 0 1-.811.439L3.709 22l-.116-.002c-.49-.007-.872-.271-1.092-.489-.22-.218-.484-.595-.5-1.08v-.014L2 20.284l.617-2.764c.065-.29.205-.573.436-.803z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsEditOutlined;
